export const EMAILRECOVERY_GET = 'EMAILRECOVERY_GET';
export const EMAILRECOVERY_UPDATE = 'EMAILRECOVERY_UPDATE';